/**
 * Settings MV2 query API — isolated from MV1 pages/Settings.jsx.
 */
import api from "@/lib/api";

export const SETTINGS_CORE_QUERY_KEY = "settings-core";

export async function fetchSettingsCoreFromApi(signal) {
  const [opexRes, staffRes, sumRes] = await Promise.allSettled([
    api.get("/opex-items"),
    api.get("/staff-members"),
    api.get("/staff-payroll/summary"),
  ]);
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");

  let opexItems = [];
  let opexTotal = 0;
  let opexFailed = false;
  if (opexRes.status === "fulfilled") {
    opexItems = opexRes.value.data.items || [];
    opexTotal = opexRes.value.data.total_monthly || 0;
  } else {
    opexFailed = true;
  }

  let staffList = [];
  let staffFailed = false;
  if (staffRes.status === "fulfilled") {
    staffList = staffRes.value.data.staff || [];
  } else {
    staffFailed = true;
  }

  let payrollSummaryMonths = [];
  if (sumRes.status === "fulfilled") {
    payrollSummaryMonths = sumRes.value.data.months || [];
  }

  return {
    opexItems,
    opexTotal,
    staffList,
    payrollSummaryMonths,
    opexFailed,
    staffFailed,
  };
}
